import { createReducer } from "@reduxjs/toolkit";
import {
  CREATE_TEMPLATEAPPS,
  EDIT_TEMPLATEAPPS,
  TEMPLATEAPPS_ERROR,
  TEMPLATEAPPS_LIST,
  TEMPLATEAPPS_LOADING,
} from "../actions/types";

const initialState = {
  error: "",
  loading: false,
  data: [],
};

const templateAppsReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(TEMPLATEAPPS_LOADING, (state) => {
      state.loading = true;
    })
    .addCase(TEMPLATEAPPS_ERROR, (state, { payload }) => {
      state.error = payload;
      state.loading = false;
    })
    .addCase(TEMPLATEAPPS_LIST, (state, { payload }) => {
      state.data = payload;
      state.loading = false;
    })
    .addCase(CREATE_TEMPLATEAPPS, (state, { payload }) => {
      Array.isArray(state.data)
        ? state.data.push(payload)
        : (state.data = [payload]);
      state.loading = false;
    })
    .addCase(EDIT_TEMPLATEAPPS, (state, { payload }) => {
      const index = state.data.findIndex((e) => e?.id === payload?.id);
      state.data[index] = payload;
      state.loading = false;
    });
});

export default templateAppsReducer;
